// https://github.com/konvajs/konva
// https://konvajs.org/

$(document).ready(function(){
  $("#base_image").change(function() {
    if (this.files[0]) {
      img = new Image()
      var objectUrl = window.URL.createObjectURL(this.files[0])
      img.onload = function() {
        renderObiEditor(this.width, this.height)
      }
      img.src = objectUrl
    }
  })
})

const renderObiEditor = (baseW, baseH) => {
  //
  // canvasの大きさを決定
  //
  var displayWidth = $(".qrcode-container").width()
  var displayHeight = displayWidth * baseH / baseW

  //
  // 画像のレイヤーが乗るステージを作成
  //
  var stage = new Konva.Stage({
    container: 'canvas',
    width: displayWidth,
    height: displayHeight,
  })

  var layer = new Konva.Layer()
  stage.add(layer)


  //
  // レイヤーをリサイズ・回転可能にする
  //
  var tr = new Konva.Transformer()
  layer.add(tr)

  //
  // QRコードの読み取り
  //
  var image = document.getElementById("qrcode")
  var imageObj = new Image()
  imageObj.onload = function(imgRect) {
    imgRect = rectImage(this)
    rect = imgRect
    layer.add(imgRect)
  }
  imageObj.src = image.src

  //
  // 帯画像の読み込み・登録
  //
  var imageObj2 = new Image()
  readURL($("#base_image")[0], imageObj2)
  imageObj2.onload = function() {
    var img = rectBaseImage(imageObj2, this)
    layer.add(img)
    img.moveToBottom()
  }


  //
  // レイヤーオブジェクトのレンダリング
  //
  layer.draw()
  stage.add(layer)

  //
  // 画像の保存
  //
  handleSaveAction(layer, baseW)

  //
  // マウス操作のハンドリング
  //
  var selectionRectangle = new Konva.Rect({
    fill: 'rgba(0,0,255,0.5)',
  })

  var x1, y1, x2, y2
  stage.on('mousedown touchstart', (e) => {
    if (e.target !== stage) {
      return
    }
    x1 = stage.getPointerPosition().x
    y1 = stage.getPointerPosition().y
    x2 = stage.getPointerPosition().x
    y2 = stage.getPointerPosition().y

    selectionRectangle.visible(true)
    selectionRectangle.width(0)
    selectionRectangle.height(0)
    layer.draw()
  })

  stage.on('mousemove touchmove', () => {
    if (!selectionRectangle.visible()) {
      return
    }
    x2 = stage.getPointerPosition().x
    y2 = stage.getPointerPosition().y

    selectionRectangle.setAttrs({
      x: Math.min(x1, x2),
      y: Math.min(y1, y2),
      width: Math.abs(x2 - x1),
      height: Math.abs(y2 - y1),
    })

    layer.batchDraw()
  })

  stage.on('mouseup touchend', () => {
    if (!selectionRectangle.visible()) {
      return
    }
    setTimeout(() => {
      selectionRectangle.visible(false)
      layer.batchDraw()
    })

    var shapes = stage.find('.rect').toArray()
    var box = selectionRectangle.getClientRect()
    var selected = shapes.filter((shape) =>
      Konva.Util.haveIntersection(box, shape.getClientRect()),
    )
    tr.nodes(selected)
    layer.batchDraw()
  })

  stage.on('click tap', function(e) {
    if (selectionRectangle.visible()) {
      return
    }

    if (e.target === stage) {
      tr.nodes([])
      layer.draw()
      return
    }

    const metaPressed = e.evt.shiftKey || e.evt.ctrlKey || e.evt.metaKey
    const isSelected = tr.nodes().indexOf(e.target) >= 0

    if (!metaPressed && !isSelected) {
      tr.nodes([e.target])
    } else if (metaPressed && isSelected) {
      const nodes = tr.nodes().slice()
      nodes.splice(nodes.indexOf(e.target), 1)
      tr.nodes(nodes)
    } else if (metaPressed && !isSelected) {
      const nodes = tr.nodes().concat([e.target])
      tr.nodes(nodes)
    }
    layer.draw()
  })
}

function rectImage(imageObj) {
  var img = new Konva.Image({
    image: imageObj,
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    draggable: true,
  })

  return img
}

function rectBaseImage(imageObj, imageRaw) {
  var displayWidth = $(".qrcode-container").width()
  var displayHeight = displayWidth * imageRaw.height / imageRaw.width

  var img = new Konva.Image({
    image: imageObj,
    x: 0,
    y: 0,
    width: displayWidth,
    height: displayHeight,
  })

  return img
}

function readURL(input, imageObj) {
  if (input.files && input.files[0]) {
    var reader = new FileReader()
    reader.onload = function(e) {
      imageObj.src = e.target.result
    }

    reader.readAsDataURL(input.files[0])
  }
}

function handleSaveAction(layer, baseW) {
  document.getElementById('save').addEventListener(
    'click',
    function() {
      var displayWidth = $(".qrcode-container").width()
      var qr = layer.getChildren(function(node) {
        return node.getClassName() === "Image"
      })[1]
      var scale = baseW / displayWidth
      var qrX = qr.x() * scale
      var qrY = qr.y() * scale
      var qrW = 200 * qr.scaleX() * scale
      $("#base_obi_image_qr_position_x").val(qrX)
      $("#base_obi_image_qr_position_y").val(qrY)
      $("#base_obi_image_qr_w").val(qrW)
      $("#submit").click()
    },
    false,
  )
}
